import FiltrarPagos from '../../../components/ui/Auditor/FiltrarPagosComponents/FiltrarPagos';

const FiltrarPagosUI = () => {
  return (
    <div className=" bg-gray-100">
        <FiltrarPagos />
    </div>
  );
};

export default FiltrarPagosUI;